
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as bWVybWFpZA from 'mermaid';
import * as d2FzbTpqcy1zdHJpbmc from './stelekit-kmp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_bWVybWFpZA_ = bWVybWFpZA;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
    'org.w3c.dom.Node_$external_class_get' : () => Node,
    'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
    'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
    'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
    'org.w3c.dom.Touch_$external_class_get' : () => Touch,
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
    'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.skiko.w3c.clipboard_$external_prop_getter' : (_this) => _this.clipboard,
    'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
    'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
    'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
    'org.jetbrains.skiko.w3c.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
    'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
    'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.node.requireExists' : () => typeof require === 'function',
    'kotlinx.io.node.requireModule' : (mod) => {
         try {
             let m = require(mod);
             if (m) return m;
             return null;
         } catch (e) {
             return null;
         }
     },
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process.env.KTOR_LOG_LEVEL,
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'dev.stapler.stelekit.browser.markSteleKitReady' : () => window.__stelekit_ready = true,
    'dev.stapler.stelekit.browser.markGraphDialogCapable' : (capable) => window.__stelekit_native_graph_picker = capable,
    'dev.stapler.stelekit.browser.markDriverBackend' : (backend) => window.__stelekit_driver_backend = backend,
    'dev.stapler.stelekit.browser.showBootError' : (message) => 
        (function() {
            window.__stelekit_boot_error = true;
            var loading = document.getElementById('loading');
            if (!loading) return;
            loading.innerHTML = '';
            var p = document.createElement('p');
            p.style.fontSize = '15px';
            p.style.maxWidth = '420px';
            p.style.textAlign = 'center';
            p.style.padding = '0 16px';
            p.textContent = message;
            loading.appendChild(p);
        })()
        ,
    'dev.stapler.stelekit.browser.setShouldWarnMirror' : (shouldWarn) => window.__stelekit_should_warn = shouldWarn,
    'dev.stapler.stelekit.browser.registerBeforeUnloadWarning' : () => 
        (function() {
            window.addEventListener("beforeunload", function(event) {
                if (window.__stelekit_should_warn) {
                    event.preventDefault();
                    event.returnValue = "";
                }
            });
        })()
        ,
    'dev.stapler.stelekit.browser.preventBrowserTabFocusTraversal' : () => 
        (function() {
            window.addEventListener("keydown", function(event) {
                if (event.key === "Tab" && event.target && event.target.tagName === "CANVAS") {
                    event.preventDefault();
                }
            }, true);
        })()
        ,
    'dev.stapler.stelekit.db.storageEstimateSupported' : () => typeof navigator.storage !== 'undefined' && typeof navigator.storage.estimate === 'function',
    'dev.stapler.stelekit.db.storageEstimatePromise' : () => navigator.storage.estimate(),
    'dev.stapler.stelekit.db.estimateQuota' : (estimate) => estimate.quota || 0,
    'dev.stapler.stelekit.db.estimateUsage' : (estimate) => estimate.usage || 0,
    'dev.stapler.stelekit.db.createSqliteWorker' : (scriptPath) => new Worker(scriptPath, { type: 'module' }),
    'dev.stapler.stelekit.db.workerPostMessage' : (worker, message) => worker.postMessage(message),
    'dev.stapler.stelekit.db.buildInitMessage' : (dbPath, mode) => ({ type: 'init', dbPath: dbPath, mode: mode }),
    'dev.stapler.stelekit.db.buildQueryMessage' : (id, sql, bindArray) => ({ type: 'query', id: id, sql: sql, bind: bindArray }),
    'dev.stapler.stelekit.db.buildTransactionBeginMessage' : (id) => ({ type: 'transaction-begin', id: id }),
    'dev.stapler.stelekit.db.buildTransactionEndMessage' : (id, successful) => ({ type: 'transaction-end', id: id, successful: successful }),
    'dev.stapler.stelekit.db.buildExecuteLongMessage' : (id, sql, bindArray) => ({ type: 'execute-long', id: id, sql: sql, bind: bindArray }),
    'dev.stapler.stelekit.db.emptyJsArray' : () => [],
    'dev.stapler.stelekit.db.jsArrayPushString' : (arr, value) => arr.push(value),
    'dev.stapler.stelekit.db.jsArrayPushLong' : (arr, value) => arr.push(Number(value)),
    'dev.stapler.stelekit.db.jsArrayPushDouble' : (arr, value) => arr.push(value),
    'dev.stapler.stelekit.db.jsArrayPushNull' : (arr) => arr.push(null),
    'dev.stapler.stelekit.db.getMessageRows' : (msg) => msg.rows,
    'dev.stapler.stelekit.db.getMessageChanges' : (msg) => BigInt(msg.value),
    'dev.stapler.stelekit.db.getMessageBackend' : (msg) => msg.backend,
    'dev.stapler.stelekit.db.getMessageWarning' : (msg) => msg.warning || null,
    'dev.stapler.stelekit.db.rowsLength' : (rows) => rows.length | 0,
    'dev.stapler.stelekit.db.getRow' : (rows, index) => rows[index],
    'dev.stapler.stelekit.db.getColumnNames' : (row) => Object.keys(row),
    'dev.stapler.stelekit.db.jsArrayLength' : (arr) => arr.length | 0,
    'dev.stapler.stelekit.db.jsArrayGetString' : (arr, index) => arr[index],
    'dev.stapler.stelekit.db.getColumnValue' : (row, name) => row[name] ?? null,
    'dev.stapler.stelekit.db.jsValueToString' : (v) => String(v),
    'dev.stapler.stelekit.db.jsValueToDouble' : (v) => Number(v),
    'dev.stapler.stelekit.db.jsValueIsNull' : (v) => v === null || v === undefined,
    'dev.stapler.stelekit.db.createWorkerReadyPromise' : (worker) => 
        new Promise(function(resolve) {
            function onReady(e) {
                if (e.data.type === 'ready') {
                    worker.removeEventListener('message', onReady);
                    resolve(e.data);
                }
            }
            worker.addEventListener('message', onReady);
        })
    ,
    'dev.stapler.stelekit.db.createWorkerResponsePromise' : (worker, id) => 
        new Promise(function(resolve, reject) {
            function handler(e) {
                var data = e.data;
                if ((data.type === 'result' || data.type === 'long-result' || data.type === 'error') && (data.id | 0) === (id | 0)) {
                    worker.removeEventListener('message', handler);
                    if (data.type === 'error') {
                        reject(new Error(data.message));
                    } else {
                        resolve(data);
                    }
                }
            }
            worker.addEventListener('message', handler);
        })
    ,
    'dev.stapler.stelekit.git.jsRequestLockHandle' : (name) => 
        (function() {
            var acquiredResolve;
            var releaseResolve;
            var acquired = new Promise(function(resolve) { acquiredResolve = resolve; });
            var held = new Promise(function(resolve) { releaseResolve = resolve; });
            var done = navigator.locks.request(name, function(lock) {
                acquiredResolve(lock);
                return held;
            });
            return { acquired: acquired, release: releaseResolve, done: done };
        })()
        ,
    'dev.stapler.stelekit.git.jsHandleAcquiredPromise' : (handle) => handle.acquired,
    'dev.stapler.stelekit.git.jsHandleRelease' : (handle) => handle.release(),
    'dev.stapler.stelekit.git.jsHandleDonePromise' : (handle) => handle.done,
    'dev.stapler.stelekit.platform.base64ToUint8Array' : (base64) => 
        (function() {
            var binary = atob(base64);
            var len = binary.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) { bytes[i] = binary.charCodeAt(i); }
            return bytes;
        })()
    ,
    'dev.stapler.stelekit.platform.arrayBufferToBase64' : (buffer) => 
        (function() {
            var bytes = new Uint8Array(buffer);
            var binary = '';
            var chunk = 0x8000;
            for (var i = 0; i < bytes.length; i += chunk) {
                binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
            }
            return btoa(binary);
        })()
    ,
    'dev.stapler.stelekit.platform.jsReloadWithEphemeralParam' : () => window.location.href = window.location.pathname + '?mode=ephemeral',
    'dev.stapler.stelekit.platform.mirrorPendingHostConflictCount' : (count) => window.__stelekit_pending_host_conflicts = count,
    'dev.stapler.stelekit.platform.mirrorPendingHostBytesConflictCount' : (count) => window.__stelekit_pending_host_bytes_conflicts = count,
    'dev.stapler.stelekit.platform.idbOpenPromise' : (name, version) => new Promise(function(res, rej) { var r = indexedDB.open(name, version); r.onupgradeneeded = function(e) { e.target.result.createObjectStore('handles'); }; r.onsuccess = function(e) { res(e.target.result); }; r.onerror = function(e) { rej(e); }; }),
    'dev.stapler.stelekit.platform.idbPutHandlePromise' : (db, key, handle) => new Promise(function(res, rej) { var tx = db.transaction('handles', 'readwrite'); tx.objectStore('handles').put(handle, key); tx.oncomplete = function() { res(handle); }; tx.onerror = function(e) { rej(e); }; }),
    'dev.stapler.stelekit.platform.idbGetHandlePromise' : (db, key) => new Promise(function(res) { var tx = db.transaction('handles', 'readonly'); var req = tx.objectStore('handles').get(key); req.onsuccess = function() { res(req.result || null); }; req.onerror = function() { res(null); }; }),
    'dev.stapler.stelekit.platform.idbDeleteHandlePromise' : (db, key) => new Promise(function(res, rej) { var tx = db.transaction('handles', 'readwrite'); tx.objectStore('handles').delete(key); tx.oncomplete = function() { res(true); }; tx.onerror = function(e) { rej(e); }; }),
    'dev.stapler.stelekit.platform.queryPermissionPromise' : (handle, mode) => handle.queryPermission({ mode: mode }),
    'dev.stapler.stelekit.platform.requestPermissionPromise' : (handle, mode) => handle.requestPermission({ mode: mode }),
    'dev.stapler.stelekit.platform.jsStringValue' : (v) => String(v),
    'dev.stapler.stelekit.platform.jsAnyToUtf8String' : (v) => String(v),
    'dev.stapler.stelekit.platform.fileSystemObserverSupported' : () => typeof FileSystemObserver === 'function',
    'dev.stapler.stelekit.platform.newFileSystemObserver' : (callback) => new FileSystemObserver(function(records) { callback(records); }),
    'dev.stapler.stelekit.platform.observePromise' : (observer, handle, recursive) => observer.observe(handle, { recursive: recursive }),
    'dev.stapler.stelekit.platform.disconnectObserver' : (observer) => observer.disconnect(),
    'dev.stapler.stelekit.platform.changeRecordType' : (record) => record.type,
    'dev.stapler.stelekit.platform.changeRecordRelativePathArray' : (record) => record.relativePathComponents,
    'dev.stapler.stelekit.platform.jsArrayLength' : (arr) => arr.length | 0,
    'dev.stapler.stelekit.platform.jsArrayGetString' : (arr, index) => arr[index],
    'dev.stapler.stelekit.platform.jsRecordsLength' : (records) => records.length | 0,
    'dev.stapler.stelekit.platform.jsRecordsGet' : (records, index) => records[index],
    'dev.stapler.stelekit.platform.fileLastModified' : (file) => BigInt(file.lastModified),
    'dev.stapler.stelekit.platform.fileSize' : (file) => BigInt(file.size),
    'dev.stapler.stelekit.platform.jsVisibilityVisiblePromise' : () => 
        (function() {
            return new Promise(function(resolve) {
                if (typeof document === 'undefined' || typeof document.addEventListener !== 'function') {
                    return;
                }
                function handler() {
                    if (document.visibilityState === 'visible') {
                        document.removeEventListener('visibilitychange', handler);
                        resolve(null);
                    }
                }
                document.addEventListener('visibilitychange', handler);
            });
        })()
        ,
    'dev.stapler.stelekit.platform.storagePersistSupported' : () => typeof navigator.storage !== 'undefined' && typeof navigator.storage.persist === 'function',
    'dev.stapler.stelekit.platform.jsStoragePersistPromise' : () => navigator.storage.persist(),
    'dev.stapler.stelekit.platform.jsBooleanValue' : (v) => v === true,
    'dev.stapler.stelekit.platform.jsOpenInBrowser' : (url) => window.open(url, '_blank'),
    'dev.stapler.stelekit.platform.showDirectoryPickerSupported' : () => typeof window.showDirectoryPicker === 'function',
    'dev.stapler.stelekit.platform.showDirectoryPickerPromise' : () => window.showDirectoryPicker(),
    'dev.stapler.stelekit.platform.opfsRootPromise' : () => navigator.storage.getDirectory(),
    'dev.stapler.stelekit.platform.directoryHandlePromise' : (parent, name, create) => parent.getDirectoryHandle(name, { create: create }),
    'dev.stapler.stelekit.platform.fileHandlePromise' : (parent, name, create) => parent.getFileHandle(name, { create: create }),
    'dev.stapler.stelekit.platform.iteratorValues' : (handle) => handle.values(),
    'dev.stapler.stelekit.platform.iteratorNext' : (iter) => iter.next(),
    'dev.stapler.stelekit.platform.iterResultDone' : (result) => result.done === true,
    'dev.stapler.stelekit.platform.iterResultValue' : (result) => result.value,
    'dev.stapler.stelekit.platform.getEntryName' : (entry) => entry.name,
    'dev.stapler.stelekit.platform.isFileEntry' : (entry) => entry.kind === 'file',
    'dev.stapler.stelekit.platform.isDirectoryEntry' : (entry) => entry.kind === 'directory',
    'dev.stapler.stelekit.platform.fileHandleGetFile' : (handle) => handle.getFile(),
    'dev.stapler.stelekit.platform.fileText' : (file) => file.text(),
    'dev.stapler.stelekit.platform.jsStringValue_1' : (v) => String(v),
    'dev.stapler.stelekit.platform.fileHandleCreateWritable' : (handle) => handle.createWritable(),
    'dev.stapler.stelekit.platform.writableWrite' : (writable, content) => writable.write(content),
    'dev.stapler.stelekit.platform.writableWriteBuffer' : (writable, buffer) => writable.write(buffer),
    'dev.stapler.stelekit.platform.writableClose' : (writable) => writable.close(),
    'dev.stapler.stelekit.platform.writableAbort' : (writable) => writable.abort(),
    'dev.stapler.stelekit.platform.dirRemoveEntry' : (dir, name) => dir.removeEntry(name),
    'dev.stapler.stelekit.platform.dirRemoveEntryRecursivePromise' : (dir, name) => dir.removeEntry(name, { recursive: true }),
    'dev.stapler.stelekit.platform.createObjectUrlFromFile' : (file) => URL.createObjectURL(file),
    'dev.stapler.stelekit.platform.fileArrayBuffer' : (file) => file.arrayBuffer(),
    'dev.stapler.stelekit.platform.jsArrayBufferLength' : (buffer) => new Uint8Array(buffer).length,
    'dev.stapler.stelekit.platform.jsArrayBufferByteAt' : (buffer, index) => new Uint8Array(buffer)[index],
    'dev.stapler.stelekit.platform.newJsByteArray' : () => [],
    'dev.stapler.stelekit.platform.pushJsByte' : (arr, value) => arr.push(value),
    'dev.stapler.stelekit.platform.jsByteArrayToBuffer' : (arr) => new Uint8Array(arr).buffer,
    'dev.stapler.stelekit.platform.jsVisibilityHiddenPromise' : () => 
        (function() {
            return new Promise(function(resolve) {
                if (typeof document === 'undefined' || typeof document.addEventListener !== 'function') {
                    return;
                }
                function handler() {
                    if (document.visibilityState === 'hidden') {
                        document.removeEventListener('visibilitychange', handler);
                        resolve(null);
                    }
                }
                document.addEventListener('visibilitychange', handler);
            });
        })()
        ,
    'dev.stapler.stelekit.platform.jsPageHidePromise' : () => 
        (function() {
            return new Promise(function(resolve) {
                if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
                    return;
                }
                var settled = false;
                function handler() {
                    if (settled) return;
                    settled = true;
                    window.removeEventListener('pagehide', handler);
                    window.removeEventListener('beforeunload', handler);
                    resolve(null);
                }
                window.addEventListener('pagehide', handler);
                window.addEventListener('beforeunload', handler);
            });
        })()
        ,
    'dev.stapler.stelekit.platform.triggerBrowserTextDownload' : (filename, content, mimeType) => (function() {
            var blob = new Blob([content], { type: mimeType });
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url; a.download = filename;
            document.body.appendChild(a); a.click(); document.body.removeChild(a);
            setTimeout(function() { URL.revokeObjectURL(url); }, 1000);
        })(),
    'dev.stapler.stelekit.platform.jsRequestLockHandle' : (name) => 
        (function() {
            var acquiredResolve;
            var releaseResolve;
            var acquired = new Promise(function(resolve) { acquiredResolve = resolve; });
            var held = new Promise(function(resolve) { releaseResolve = resolve; });
            var done = navigator.locks.request(name, function(lock) {
                acquiredResolve(lock);
                return held;
            });
            return { acquired: acquired, release: releaseResolve, done: done };
        })()
        ,
    'dev.stapler.stelekit.platform.jsHandleAcquiredPromise' : (handle) => handle.acquired,
    'dev.stapler.stelekit.platform.jsHandleRelease' : (handle) => handle.release(),
    'dev.stapler.stelekit.platform.jsHandleDonePromise' : (handle) => handle.done,
    'dev.stapler.stelekit.platform.jsRequestLockHandleIfAvailable' : (name) => 
        (function() {
            var acquiredResolve;
            var releaseResolve;
            var acquired = new Promise(function(resolve) { acquiredResolve = resolve; });
            var held = new Promise(function(resolve) { releaseResolve = resolve; });
            var done = navigator.locks.request(name, { ifAvailable: true }, function(lock) {
                if (lock === null) {
                    acquiredResolve(null);
                    return Promise.resolve();
                }
                acquiredResolve(lock);
                return held;
            });
            return { acquired: acquired, release: releaseResolve, done: done };
        })()
        ,
    'dev.stapler.stelekit.platform.jsHandleAcquiredPromiseOrNull' : (handle) => handle.acquired,
    'dev.stapler.stelekit.platform.security.subtleCryptoAvailable' : () => typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined',
    'dev.stapler.stelekit.platform.security.randomBytesJs' : (length) => crypto.getRandomValues(new Uint8Array(length)),
    'dev.stapler.stelekit.platform.security.importAesKeyPromise' : (rawKey) => crypto.subtle.importKey('raw', rawKey, { name: 'AES-GCM' }, false, ['encrypt', 'decrypt']),
    'dev.stapler.stelekit.platform.security.subtleEncryptPromise' : (key, iv, data) => crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, key, data),
    'dev.stapler.stelekit.platform.security.subtleDecryptPromise' : (key, iv, data) => crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, key, data),
    'dev.stapler.stelekit.platform.security.localStorageLength' : () => localStorage.length,
    'dev.stapler.stelekit.platform.security.localStorageKeyAt' : (index) => localStorage.key(index),
    'dev.stapler.stelekit.service.createObjectUrlFromBuffer' : (buffer, mimeType) => URL.createObjectURL(new Blob([buffer], { type: mimeType })),
    'dev.stapler.stelekit.service.pickImageFileJs' : () => (function() {
        return new Promise(function(resolve, reject) {
            var input = document.createElement('input');
            input.type = 'file'; input.accept = 'image/*';
            input.addEventListener('change', function() {
                if (input.files && input.files[0]) resolve(input.files[0]);
                else reject(new Error('no-file'));
            });
            input.addEventListener('cancel', function() { reject(new Error('cancelled')); });
            input.click();
        });
    })(),
    'dev.stapler.stelekit.sync.jsFetchWithHeader' : (url, headerName, headerValue) => fetch(url, { headers: { [headerName]: headerValue, 'Accept': 'application/vnd.github+json' } }),
    'dev.stapler.stelekit.sync.jsFetchAnon' : (url) => fetch(url, { headers: { 'Accept': 'application/vnd.github+json' } }),
    'dev.stapler.stelekit.sync.jsResponseStatus' : (response) => response.status | 0,
    'dev.stapler.stelekit.sync.jsResponseHeader' : (response, name) => response.headers.get(name) || null,
    'dev.stapler.stelekit.sync.jsResponseText' : (response) => response.text(),
    'dev.stapler.stelekit.sync.jsStringValue' : (v) => String(v),
    'dev.stapler.stelekit.ui.jsPushHistoryGuard' : () => window.history.pushState({ stelekitBackGuard: true }, ''),
    'dev.stapler.stelekit.ui.jsPopStatePromise' : () => 
        (function() {
            return new Promise(function(resolve) {
                function handler(event) {
                    window.removeEventListener('popstate', handler);
                    resolve(null);
                }
                window.addEventListener('popstate', handler);
            });
        })()
        ,
    'dev.stapler.stelekit.ui.hasNavigatorShare' : () => typeof navigator.share === 'function',
    'dev.stapler.stelekit.ui.navigatorShareText' : (text) => navigator.share({ text: text }),
    'dev.stapler.stelekit.ui.triggerBlobDownload' : (content, filename) => (function() {
            var blob = new Blob([content], { type: 'text/plain' });
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url; a.download = filename;
            document.body.appendChild(a); a.click(); document.body.removeChild(a);
            setTimeout(function() { URL.revokeObjectURL(url); }, 1000);
        })(),
    'dev.stapler.stelekit.ui.triggerBinaryBlobDownload' : (buffer, filename) => (function() {
            var blob = new Blob([buffer], { type: 'application/zip' });
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url; a.download = filename;
            document.body.appendChild(a); a.click(); document.body.removeChild(a);
            setTimeout(function() { URL.revokeObjectURL(url); }, 1000);
        })(),
    'dev.stapler.stelekit.ui.components.installBodyDropListener' : (onFiles) => 
        (function() {
            document.body.addEventListener('dragenter', function(e) { e.preventDefault(); });
            document.body.addEventListener('dragover', function(e) { e.preventDefault(); });
            document.body.addEventListener('drop', function(e) {
                e.preventDefault();
                onFiles(Array.from(e.dataTransfer.files));
            });
        })()
    ,
    'dev.stapler.stelekit.ui.components.jsFileArrayLength' : (arr) => arr.length | 0,
    'dev.stapler.stelekit.ui.components.jsFileArrayGet' : (arr, index) => arr[index],
    'dev.stapler.stelekit.ui.components.jsFileName' : (file) => file.name,
    'dev.stapler.stelekit.ui.components.fileArrayBufferPromise' : (file) => file.arrayBuffer(),
    'dev.stapler.stelekit.ui.components.buildMermaidInitConfig' : (securityLevel) => ({ startOnLoad: false, securityLevel: securityLevel }),
    'dev.stapler.stelekit.ui.components.mermaidRenderResultSvg' : (result) => result.svg,
    'dev.stapler.stelekit.ui.components.initialize_$external_fun' : (_this, p0) => _this.initialize(p0),
    'dev.stapler.stelekit.ui.components.render_$external_fun' : (_this, p0, p1) => _this.render(p0, p1),
    'dev.stapler.stelekit.ui.components.MermaidJsBindings_$external_object_getInstance' : () => _ref_bWVybWFpZA_,
    'dev.stapler.stelekit.ui.components.createMermaidOverlayElement' : () => 
        (function() {
            var div = document.createElement('div');
            div.setAttribute('data-mermaid-overlay', 'true');
            div.style.position = 'absolute';
            div.style.pointerEvents = 'none';
            div.style.overflow = 'visible';
            div.style.zIndex = '1000';
            return div;
        })()
        ,
    'dev.stapler.stelekit.ui.components.appendMermaidOverlayElement' : (element) => document.body.appendChild(element),
    'dev.stapler.stelekit.ui.components.removeMermaidOverlayElement' : (element) => 
        (function() {
            if (element.parentNode) { element.parentNode.removeChild(element); }
        })()
        ,
    'dev.stapler.stelekit.ui.components.setMermaidOverlayHtml' : (element, svg) => element.innerHTML = svg,
    'dev.stapler.stelekit.ui.components.positionMermaidOverlayElement' : (element, left, top, width, height) => 
        (function() {
            element.style.left = left + 'px';
            element.style.top = top + 'px';
            element.style.width = width + 'px';
            element.style.height = height + 'px';
        })()
        ,
    'dev.stapler.stelekit.util.jsPerformanceNow' : () => performance.now()
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    